<template>
    <div class="grid-x vuw-full-height">
        <div class="cell small-12 vuw-text-small">
            {{ text }}
        </div>
    </div>
</template>

<script>
import {defineComponent} from "@vue/composition-api";

export default defineComponent({
    name: "TextAtom",
    props: {
        text: {
            type: String,
            required: true,
            default: ""
        }
    }
})
</script>